import { HttpMethods, restRequest } from 'common-src/features/rest';

export const getPatientIntegrationsZusRequest = (query, params) =>
  restRequest({
    uri: 'patientIntegrationsZus',
    query,
    method: HttpMethods.Get,
    ...params,
  });

export const createPatientIntegrationsZus = (body, params) =>
  restRequest({
    uri: 'patientIntegrationsZus',
    method: HttpMethods.Post,
    body,
    ...params,
  });

export const createZusPatientFromAthena = (patientId, params) =>
  restRequest({
    uri: `patientIntegrationsZus/create/${patientId}`,
    method: HttpMethods.Post,
    body: {},
    ...params,
  });

export const queueCreateZusPatientFromAthena = (patientId, params) =>
  restRequest({
    uri: `patientIntegrationsZus/create/${patientId}/queue`,
    method: HttpMethods.Post,
    body: {},
    ...params,
  });

export const triggerZusPatientSetupWorkflow = (patientId, params) =>
  restRequest({
    uri: `patientIntegrationsZus/workflow/${patientId}/patient-setup`,
    method: HttpMethods.Post,
    body: {},
    ...params,
  });

export const updatePatientIntegrationsZus = (body, params) =>
  restRequest({
    uri: `patientIntegrationsZus/${body.id}`,
    method: HttpMethods.Patch,
    body,
    ...params,
  });

export const deletePatientIntegrationsZus = (id, params) =>
  restRequest({
    uri: `patientIntegrationsZus/${id}`,
    method: HttpMethods.Delete,
    ...params,
  });

export const syncPatientIntegrationsZus = (patientId, params) =>
  restRequest({
    uri: `patientIntegrationsZus/sync/${patientId}`,
    method: HttpMethods.Post,
    body: {},
    ...params,
  });

export const queueSyncPatientIntegrationsZus = (patientId, params) =>
  restRequest({
    uri: `patientIntegrationsZus/sync/${patientId}/queue`,
    method: HttpMethods.Post,
    body: {},
    ...params,
  });

export const startZusPatientHistoryPull = (patientId, query = {}, params) =>
  restRequest({
    uri: `patientIntegrationsZus/history/${patientId}/start`,
    method: HttpMethods.Post,
    query,
    body: {},
    ...params,
  });

export const queueStartZusPatientHistoryPull = (patientId, query = {}, params) =>
  restRequest({
    uri: `patientIntegrationsZus/history/${patientId}/start/queue`,
    method: HttpMethods.Post,
    query,
    body: {},
    ...params,
  });

export const refreshZusPatientHistoryPullStatus = (patientId, params) =>
  restRequest({
    uri: `patientIntegrationsZus/history/${patientId}/refresh`,
    method: HttpMethods.Post,
    body: {},
    ...params,
  });
